import history from '../../util/history'

const toDetailView = id => {
  history.push(`/plan/${id}/detail`)

  return true
}

export default toDetailView
